import React, { useEffect } from 'react'
import { FirstGrid, HomeImageWrapper, HomeWrapper, SecondGrid } from './HomeStyle'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper";
import { SlideData } from './data';
import styled from 'styled-components'
import Image1 from '../../assets/images/list_home/1.png'
import Image2 from '../../assets/images/list_home/2.png'
import Image3 from '../../assets/images/list_home/3.png'
import Image4 from '../../assets/images/list_home/4.png'
import Image5 from '../../assets/images/list_home/5.jpg'
import Image6 from '../../assets/images/list_home/6.png'
import Image7 from '../../assets/images/list_home/7.jpg'
import Image8 from '../../assets/images/list_home/8.png'
import { useNavigate } from 'react-router-dom';

const swiperConfig = {
  loop: true,
  grabCursor: true,
  navigation: true,
  pagination: true,
  modules: [Navigation, Autoplay, Pagination],
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  }
}
const HeroItem = styled.div`
    background-image: url(${({bgImg}) => bgImg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 60vw;
    max-height: 800px;
    cursor: pointer;
    position: relative;
    &::before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.1);
        content: '';
    }
`
export default function Home() {
  const navigate = useNavigate()
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])
  return (
    <HomeWrapper>
      {
        <Swiper {...swiperConfig}>
          {
            SlideData.map((slide, idx) => (
              <SwiperSlide key={idx}>
                <HeroItem bgImg={slide.img} onClick={() => navigate('/detail')} />
              </SwiperSlide>
            ))
          }
        </Swiper>
      }
      <HomeImageWrapper>
        <FirstGrid>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image1} alt="gambar" /></div>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image2} alt="gambar" /></div>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image3} alt="gambar" /></div>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image4} alt="gambar" /></div>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image5} alt="gambar" /></div>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image6} alt="gambar" /></div>
        </FirstGrid>
        <SecondGrid>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image7} alt="gambar" /></div>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/detail')}><img src={Image8} alt="gambar" /></div>
        </SecondGrid>
      </HomeImageWrapper>
    </HomeWrapper>
  )
}